// extracted by mini-css-extract-plugin
export default {"link":"BackArrowLink_link__bun7Y"};